/* eslint-disable import/no-cycle */
import {
  // fetchAssignedToMeReports,
  fetchMyTeamReports,
  fetchReportsAssignedByUser,
  fetchNestedUserReports,
} from "apis/coachup";
import { put, takeLatest } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { coachupAction } from "../slice/coachup";

export function* getMyTeamReportsData({ payload }) {
  try {
    const response = yield fetchMyTeamReports(payload);
    if (response?.data?.success) {
      yield put(coachupAction.getMyTeamReportsSuccess(response.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(coachupAction.getMyTeamReportsFailure(response));
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );

    yield put(coachupAction.getMyTeamReportsFailure());
  }
}

export function* getfetchReportsAssignedByUserData({ payload }) {
  try {
    const response = yield fetchReportsAssignedByUser(payload);
    if (response?.data?.success) {
      yield put(coachupAction.getReportsAssignedByUserSuccess(response.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(coachupAction.getReportsAssignedByUserFailure(response));
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(coachupAction.getReportsAssignedByUserFailure());
  }
}

export function* getfetchAssignedToMeOpenReportsData({ payload }) {
  try {
    const response = yield fetchNestedUserReports(payload);
    if (response?.data?.success) {
      yield put(coachupAction.getAssignedToMeOpenSuccess(response.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(coachupAction.getAssignedToMeOpenFailure(response));
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(coachupAction.getAssignedToMeOpenFailure());
  }
}

export function* getfetchAssignedToMeArchiveReportsData({ payload }) {
  try {
    const response = yield fetchNestedUserReports(payload);
    if (response?.data?.success) {
      yield put(coachupAction.getAssignedToMeArchiveSuccess(response.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(coachupAction.getAssignedToMeArchiveFailure(response));
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(coachupAction.getAssignedToMeArchiveFailure());
  }
}

export function* watchCoachupdAsync() {
  yield takeLatest(coachupAction.getMyTeamReportsRequest, getMyTeamReportsData);
  yield takeLatest(
    coachupAction.getReportsAssignedByUserRequest,
    getfetchReportsAssignedByUserData
  );

  yield takeLatest(coachupAction.getAssignedToMeOpenRequest, getfetchAssignedToMeOpenReportsData);
  yield takeLatest(
    coachupAction.getasAssignedToMeArchiveRequest,
    getfetchAssignedToMeArchiveReportsData
  );
}
